/* eslint-disable */
import "./DataListItem.css";
import React, { Component } from "react";

import ReactTooltip from "react-tooltip";
class DataListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    onItemClick = () => {
        console.log("clicked")
        this.setState({ expanded: !this.state.expanded });
    };

    render() {
        let classWind = "";
        let kmhSpeed = "";
        if (this.props.data.wind.speed) {
            const windSpeed = Math.round(
                Number(this.props.data.wind.speed.replace(/[^0-9\.]+/g, ""))
            );
            if (windSpeed === 0) {
                classWind = "tdBf0";
            } else if (windSpeed === 1 || windSpeed === 2) {
                classWind = "tdBf12";
            } else if (windSpeed === 3 || windSpeed === 4) {
                classWind = "tdBf34";
            } else if (windSpeed >= 5 && windSpeed <= 7) {
                classWind = "tdBf57";
            } else if (windSpeed > 7 && windSpeed <= 10) {
                classWind = "tdBf710";
            } else if (windSpeed > 10 && windSpeed <= 16) {
                classWind = "tdBf71116";
            } else if (windSpeed > 16 && windSpeed <= 21) {
                classWind = "tdBf71721";
            } else if (windSpeed > 21 && windSpeed <= 30) {
                classWind = "tdBf72130";
            } else if (windSpeed > 31) {
                classWind = "tdBf731";
            }

            kmhSpeed = Number(Number(windSpeed) / Number(0.539957)).toFixed(1);
        }

        const { expanded } = this.state;

        return (
            <>
                <tr
                    className="trItem tHeadDescr border"
                    onClick={this.onItemClick}
                >
                    <td className="txtLeft tdMarginRight">
                        <p>{this.props.data.location}</p>
                    </td>
                    <td className="txtCenter">
                        <p>
                            {this.props.data.temperature.current.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                    <td className={`txtCenter ${classWind}`}>
                        <p className="pWind">
                            {this.props.data.wind.speed.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                    <td className="txtCenter">
                        <p>{this.props.data.wind.direction}</p>
                    </td>
                    <td className="txtCenter">
                        <p>
                            {this.props.data.wind.avg10minutes.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                    <td className="txtCenter">
                        <p>
                            {this.props.data.wind.raff.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                    <td className="txtCenter">
                        <p>
                            {this.props.data.humidity.current.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                    <td className="txtCenter">
                        <p>
                            {this.props.data.rain.intensity_day.replace(
                                /[^0-9\.]+/g,
                                ""
                            )}
                        </p>
                    </td>
                </tr>
                {expanded ? (
                    <>
                        <tr
                            className="trItem tHeadDescr border"
                            onClick={this.onItemClick}
                        >
                            <td className="txtLeft tdMarginRight" colSpan={5}>
                                <p className="pNoMargin">Vento</p>
                                <p className="pNoMargin">Vento AVG 10min</p>
                                <p className="pNoMargin">Vento raff. </p>
                                <p className="pNoMargin">Vento raff. (h) </p>
                                <p className="pNoMargin">Vento da</p>
                                <hr/>
                                <p className="pNoMargin">Temp.</p>
                                <p className="pNoMargin">Temp. max </p>
                                <p className="pNoMargin">Temp. max (h)</p>
                                <p className="pNoMargin">Temp. min </p>
                                <p className="pNoMargin">Temp. min (h)</p>
                                <hr/>
                                <p className="pNoMargin">Umidita'</p>
                                <p className="pNoMargin">Umidita' max </p>
                                <p className="pNoMargin">Umidita' max (h)</p>
                                <p className="pNoMargin">Umidita' min </p>
                                <p className="pNoMargin">Umidita' min (h)</p>
                                <hr/>
                                <p className="pNoMargin">P. rugiada</p>
                                <p className="pNoMargin">P. rugiada max </p>
                                <p className="pNoMargin">P. rugiada max (h)</p>
                                <p className="pNoMargin">P. rugiada min </p>
                                <p className="pNoMargin">P. rugiada min (h)</p>
                                <hr/>
                                <p className="pNoMargin">Pressione</p>
                                <p className="pNoMargin">Pressione max </p>
                                <p className="pNoMargin">Pressione max (h)</p>
                                <p className="pNoMargin">Pressione min </p>
                                <p className="pNoMargin">Pressione min (h)</p>
                                <hr/>
                                <p className="pNoMargin">Wind chill</p>
                                <p className="pNoMargin">Wind chill max </p>
                                <p className="pNoMargin">Wind chill max (h)</p>
                                <p className="pNoMargin">Wind chill min </p>
                                <p className="pNoMargin">Wind chill min (h)</p>
                                <hr/>
                            </td>
                            <td className="txtLeft tdMarginRight" colSpan={3}>
                                <p className="pNoMargin">{this.props.data.wind.speed || "-"} [kts]</p>
                                <p className="pNoMargin">{this.props.data.wind.avg10minutes || "-"} [kts]</p>
                                <p className="pNoMargin">{this.props.data.wind.raff || "-"} [kts]</p>
                                <p className="pNoMargin">{this.props.data.wind.raff_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.wind.direction || "-"}</p>
                                <hr/>
                                <p className="pNoMargin">{this.props.data.temperature.current || "-"}</p>
                                <p className="pNoMargin">{this.props.data.temperature.max || "-"}</p>
                                <p className="pNoMargin">{this.props.data.temperature.max_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.temperature.min || "-"}</p>
                                <p className="pNoMargin">{this.props.data.temperature.min_hour || "-"}</p>
                                <hr/>
                                <p className="pNoMargin">{this.props.data.humidity.current || "-"}</p>
                                <p className="pNoMargin">{this.props.data.humidity.max || "-"}</p>
                                <p className="pNoMargin">{this.props.data.humidity.max_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.humidity.min || "-"}</p>
                                <p className="pNoMargin">{this.props.data.humidity.min_hour || "-"}</p>
                                <hr/>
                                <p className="pNoMargin">{this.props.data.dew_point.current || "-"}</p>
                                <p className="pNoMargin">{this.props.data.dew_point.max || "-"}</p>
                                <p className="pNoMargin">{this.props.data.dew_point.max_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.dew_point.min || "-"}</p>
                                <p className="pNoMargin">{this.props.data.dew_point.min_hour || "-"}</p>
                                <hr/>
                                <p className="pNoMargin">{this.props.data.pressure.current || "-"}</p>
                                <p className="pNoMargin">{this.props.data.pressure.max || "-"}</p>
                                <p className="pNoMargin">{this.props.data.pressure.max_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.pressure.min || "-"}</p>
                                <p className="pNoMargin">{this.props.data.pressure.min_hour || "-"}</p>
                                <hr/>
                                <p className="pNoMargin">{this.props.data.wind_chill.current || "-"}</p>
                                <p className="pNoMargin">{this.props.data.wind_chill.max || "-"}</p>
                                <p className="pNoMargin">{this.props.data.wind_chill.max_hour || "-"}</p>
                                <p className="pNoMargin">{this.props.data.wind_chill.min || "-"}</p>
                                <p className="pNoMargin">{this.props.data.wind_chill.min_hour || "-"}</p>
                                <hr/>
                            </td>
                        </tr>
                    </>
                ) : (
                    <></>
                )}

                <ReactTooltip backgroundColor="#0080FF" />
            </>
        );
    }
}

export default DataListItem;
